import _ from 'lodash'

export function getStringOrNull(value) {
  if (!value) {
    return null
  }

  if (typeof value !== 'string') {
    return null
  }

  let trimmedValue = _.trim(value)

  if (trimmedValue.length === 0) {
    return null
  }

  return trimmedValue
}